import { useQuery } from '@tanstack/react-query';
import { cartQueryKey, type CartDisplay, loadCart, saveCart } from '@/api/registration/cart';
import { useTenantApi } from '@/account/hook/useTenantApi';
import { useGroupRegistrationQuery } from './useGroupRegistrationQuery';

export function useGroupCartQuery(eventId: string) {
  const { createTenantApiRequest, isLoading: isApiPreparing } = useTenantApi();
  const groupRegistrationQuery = useGroupRegistrationQuery(eventId);
  const groupRegistration = groupRegistrationQuery?.data;

  return useQuery<CartDisplay, Error>({
    queryKey: [cartQueryKey, { groupRegistrationId: groupRegistration?.id }],
    queryFn: async (): Promise<CartDisplay> => {
      if (!groupRegistration) {
        throw new Error('Registration not found');
      }
      let result = await loadCart(createTenantApiRequest)({ groupRegistrationId: groupRegistration.id });
      if (result.items?.length === 0) {
        result = await saveCart(createTenantApiRequest)({ groupRegistrationId: groupRegistration.id });
      }
      return result.items?.[0];
    },
    enabled: !!groupRegistration && !isApiPreparing
  });
}
